import { Route } from "react-router-dom";
import Login from "./pages/login";
import Attendance from "./pages/attendance";
import AllCourses from "./pages/allcourses";
import CourseDetails from "./pages/mainAttendance";
import StudentProfile from "./pages/studentProfile";
import AdminLogin from "./pages/adminLogin";
import AdminDashboard from "./pages/adminDashboard";
import AllTeachers from "./pages/allTeachers";
import TeacherAttendance from "./pages/teacherAttendance";
import TeacherProfile from "./pages/teacherReport";
import ProtectedRoute from "./protectedRoute";

const routes = (
    <>
        {/* Public Routes */}
        <Route exact path="/" element={<Login />} />
        <Route exact path="/admin-login" element={<AdminLogin />} />

        {/* Protected Routes */}
        <Route path="/dashboard" element={<ProtectedRoute allowedRoles={["teacher","Admin"]} element={<AllCourses />} />} />
        <Route path="/admin-dashboard" element={<ProtectedRoute allowedRoles={["Admin"]} element={<AdminDashboard />} />} />
        <Route path="/all-teachers/:deptId" element={<ProtectedRoute allowedRoles={["Admin"]} element={<AllTeachers />} />} />
        <Route path="/attendance" element={<ProtectedRoute allowedRoles={["teacher","Admin"]} element={<Attendance />} />} />
        <Route path="/teacher-attendance" element={<ProtectedRoute allowedRoles={["Admin"]} element={<TeacherAttendance />} />} />
        <Route path="/course/:courseId" element={<ProtectedRoute allowedRoles={["teacher","Admin"]} element={<CourseDetails />} />} />
        <Route path="/student" element={<ProtectedRoute allowedRoles={["teacher","Admin"]} element={<StudentProfile />} />} />
        <Route path="/teacher" element={<ProtectedRoute allowedRoles={["Admin"]} element={<TeacherProfile />} />} />
    </>
);
export default routes;